type StationMarkProps = {
  className?: string
}

/**
 * Triangulation station: the surveyor's glyph for a point whose position has
 * actually been measured. Serves as the mark across the sheet.
 */
export function StationMark({ className = '' }: StationMarkProps) {
  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M14 3.5 L24.5 22 H3.5 Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="miter"
      />
      <circle cx="14" cy="17" r="2.1" fill="currentColor" />
    </svg>
  )
}
